import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../../utils/hooks';
import { useTableRowClassNames } from './utils/useTableRowClassNames';
import { TableRowRoot } from './style';
import { tableRowRootTestId, TABLE_ROW_CLASS_PREFIX } from './constants';
import { useTableRow } from './utils/useTableRow';
import { TableRowCells } from './TableRowCells';
import { getScalarPropType } from '../../../utils/propTypes';
export var TableRow = forwardRef(function TableRow(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(TABLE_ROW_CLASS_PREFIX);
  var classNameComponents = useTableRowClassNames(TABLE_ROW_CLASS_PREFIX, className);

  var _useTableRow = useTableRow(restProps),
      rootProps = _useTableRow.rootProps,
      cellsProps = _useTableRow.cellsProps;

  return React.createElement(TableRowRoot, Object.assign({
    "data-testid": tableRowRootTestId
  }, rootProps, {
    theme: theme,
    className: classNameComponents.Root,
    ref: ref
  }), React.createElement(TableRowCells, Object.assign({}, cellsProps), children));
});
TableRow.defaultProps = {
  enableStickyTop: true,
  enableStickyColumns: true
};